import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { publish } from 'app/libs/core/PubSub';
import * as way from 'app/libs/core/PubSubWays';
import {
  // twisterType as type,
  twisterType,
} from 'app/constants/twisterType.constants';
import {
  setHomeAddressUser,
  setWorkAddressUser,
} from 'actions/Users/users.action';

import {
  upTourPartByPos,
  upTourPrevPartByPos,
  upTourPartByPosWithTimestamp,
  upPartPoints,
  setPostCountedData,
  setDistanceDurationByPartId,
  setMainTourPartDistanceAndDuration,
} from 'actions/Map/tour.full.data.action';

import {
  tourSetActiveMultiPartPointAction,
  tourOpenedMultiPartAction,
  tourSetActiveMultiPartAction,
  setLatestSearchResult,
  routeSuggestion,
  setFreeHand,
  tourPointDataAction,
  optimizeAndSaveTour,
  disableReloadCommonPageAction,
  setGPSDataLoadingStatus,
  setAutoCorrectStatus,
  setMultyTour,
  addNewDay,
  setIsClearTour,
} from 'actions/FullTour/full_tour_view.action';
import * as e from 'app/constants/TourBuilderEvents';

import store from 'app/store';
import * as types from 'actions/action_types';

import { Button, notification, Tooltip } from 'antd';

import { deleteTourDay } from 'app/components/Utility/deleteTour';
import { connect } from 'react-redux';
import initAllTourPages from './initializationAll';
import initTourBuilder from './initialization';
import { progressQueueService } from '../../../Utility/Service/progressQueue.service';

import { removePassedPoint } from '../../../../actions/Map/map.scope.action';
import {
  UndoTourIcon,
  RedoTourIcon,
  ResetIcon,
  DeleteIcon,
} from '../components/svg';
import withTranslations from '../../../HOGs/withTranslations';
import { launchFunction } from './delayLaunch';
import { withDispatch } from '../../../HOGs/customeDispatch';
import { showDeleteConfirm } from '../components/deleteConfirm';

const { isPrograssCompleted, clearProgressList } = progressQueueService;

let curPart = 0;
let parts = [];
let wasEditModeChanged = false;
let tourBuilder = null;
let allTourParts = null;

class MultyBuilder extends Component {
  constructor(props) {
    super(props);
    this.tr = this.props.tr;
  }

  componentDidMount() {
    tourBuilder = initTourBuilder({
      upPointsTourPart: this.upPointsTourPart,
      upPointsTourPartWithTimestamp: this.upPointsTourPartWithTimestamp,
      openNotification: this.openNotification,
      changeCursorWrapperClassName: this.props.changeCursorWrapperClassName,
      getMode: this.getCurrentMode,
      getTourPointData: this.tourFullDataPointData,
      setDataSelectedPoint: this.setDataSelectedPoint,
      getCurPartPoly: this.getCurPartPoly,
      tourPartActionHandler: this.tourPartActionHandler,
      saveToLatestSearchAddress: this.saveToLatestSearchAddress,
      saveWorkAddressFromMap: this.saveWorkAddressFromMap,
      saveHomeAddressFromMap: this.saveHomeAddressFromMap,
      getCorrectionStatus: this.getCorrectionStatus,
      isAutocorrectionEnabled: this.isAutocorrectionEnabled,
      isCorrectViaAvailable: this.isCorrectViaAvailable,
      isCorrectDragAvailable: this.isCorrectDragAvailable,
      loadingDataStatusGPS: this.loadingDataStatusGPS,
      changeAutoCorrectStatus: this.changeAutoCorrectStatus,
      unpaved: this.unpaved,
      highway: this.highway,
      ferry: this.ferry,
      udatePartPointsData: this.udatePartPointsData,
      isShapingVisible: this.isShapingVisible,
      getPointsData: this.getPointsData,
      saveRouteSuggestion: this.saveRouteSuggestion,
      isRidePlanMode: this.isRidePlanMode,
      isToPointMode: this.isToPointMode,
      isRoundTripMode: this.isRoundTripMode,
      isFreeHandMode: this.isFreeHandMode,
      getActiveMode: this.getActiveMode,
      setFreeHand: this.setFreeHand,
      hideFreeHand: this.hideFreeHand,
      getPartNum: this.getPartNum,
      setDistanceDurationByPartId: this.setDistanceDurationByPartId,
    });
    allTourParts = initAllTourPages({
      getMode: this.getCurrentMode,
      actionPartByKey: this.actionPartByKey,
      setActivePoint: this.setActivePoint,
      tourPartActionHandler: this.tourPartActionHandler,
      updatePointAndPart: this.updatePointAndPart,
      deleteTourPart: this.deleteTourPart,
      isMultyDay: this.isMultyDay,
      optimizeAndSaveTour: this.prepareOptimizedTourData,
      disableReloadCommonPage: this.disableReloadCommonPage,
      setDistanceDurationByPartId: this.setDistanceDurationByPartId,
      wasJustImported: this.wasJustImported,
      unpaved: this.unpaved,
      highway: this.highway,
      ferry: this.ferry,
    });
  }

  shouldComponentUpdate(nextProps) {
    const {
      currentPart,
      tourFullData,
      isEditable,
      isFullScreenModeEnabled,
      multiData,
    } = this.props;
    // need update timestamp in tourData after each dispatch
    // need compare timestamp of tourData before each updating
    wasEditModeChanged = false;
    if (currentPart !== nextProps.currentPart) return true;
    if (
      !parseInt(currentPart) &&
      multiData.parts &&
      nextProps.multiData.parts &&
      multiData.parts.length !== nextProps.multiData.parts.length
    )
      return true;

    if (!tourFullData.data || !tourFullData.data.parts) return true;

    if (isEditable !== nextProps.isEditable) {
      wasEditModeChanged = true;
      return true;
    }

    if (isFullScreenModeEnabled !== nextProps.isFullScreenModeEnabled) {
      return true;
    }

    if (nextProps.isNeedReloadCommonPage) {
      return true;
    }

    if (
      tourFullData.activeMultiPart?.twister_data?.twister_type !==
      nextProps.tourFullData.activeMultiPart?.twister_data?.twister_type
    ) {
      return true;
    }

    if (nextProps.isClearTour) {
      return true;
    }

    return false;
  }

  componentDidUpdate() {
    this.setCleanTour();
    this.cleanMapForNextData();
    this.loadModeToMap();
    this.setPassedPointFromPrevPage();
  }

  componentWillUnmount() {
    this.props.changeCursorWrapperClassName(null);
    this.cleanMapForNextData();
    tourBuilder.notify(e.TB_DISTRUCT_ITSELF);
    allTourParts.notify(e.ATP_DISTRUCT_ITSELF);
    curPart = 0;
    parts = [];
  }

  loadModeToMap() {
    const {
      changeCursorWrapperClassName,
      multiData,
      currentPart,
      tourFullData,
      isEditable,
    } = this.props;

    curPart = parseInt(currentPart);
    parts = tourFullData.data.parts ? tourFullData.data.parts.slice() : [];

    const curentPart = curPart ? curPart - 1 : 0;

    if (this.isAllMultiPartsPage()) {
      const fullTour = tourFullData.fetched
        ? { ...tourFullData.data }
        : multiData;
      allTourParts.notify(e.ATP_SET_SUBSCRIBERS_FROM_VIEW);
      allTourParts.notify(e.ATP_LOAD_TOUR_DATA_ALL_PARTS, fullTour);
    } else if (tourFullData.data.parts) {
      const { isCorrectionEnabled } = tourFullData;
      switch (tourFullData.activeMultiPart?.twister_data?.twister_type) {
        case twisterType.FreeHand:
          changeCursorWrapperClassName(null);
          tourBuilder.notify(e.TB_DESTROY_SUBSCRIBERS);
          tourBuilder.notify(e.TB_SET_SUBSCRIBERS_FROM_VIEW);
          tourBuilder.notify(e.TB_LOAD_TOUR_DATA_ONE_PART, {
            tourData: { ...parts[curentPart] },
            isEditable,
            wasEditModeChanged,
            isCorrectionEnabled,
            pointsData: this.getPointsData(),
          });
          break;
        case twisterType.ToPoint:
          changeCursorWrapperClassName(null);
          tourBuilder.notify(e.TB_DESTROY_SUBSCRIBERS);
          tourBuilder.notify(e.TB_SET_SUBSCRIBERS_FROM_VIEW);
          tourBuilder.notify(e.TB_LOAD_TOUR_DATA_ONE_PART, {
            tourData: { ...parts[curentPart] },
            isEditable,
            wasEditModeChanged,
            isCorrectionEnabled,
            pointsData: this.getPointsData(),
          });
          break;
        case twisterType.RoundTrip:
          changeCursorWrapperClassName(null);
          tourBuilder.notify(e.TB_DESTROY_SUBSCRIBERS);
          tourBuilder.notify(e.TB_SET_SUBSCRIBERS_FROM_VIEW);
          tourBuilder.notify(e.TB_LOAD_TOUR_DATA_ONE_PART, {
            tourData: { ...parts[curentPart] },
            isEditable,
            wasEditModeChanged,
            isCorrectionEnabled,
            pointsData: this.getPointsData(),
          });
          break;
        default:
          tourBuilder.notify(e.TB_SET_SUBSCRIBERS_FROM_VIEW);
          tourBuilder.notify(e.TB_LOAD_TOUR_DATA_ONE_PART, {
            tourData: { ...parts[curentPart] },
            isEditable,
            wasEditModeChanged,
            isCorrectionEnabled,
            pointsData: this.getPointsData(),
          });
          break;
      }
    }
  }

  setCleanTour = () => {
    const { isClearTour, ownDispatch } = this.props;
    if (isClearTour) {
      ownDispatch(setIsClearTour(false));
      this.cleanMapForNextData();
    }
  };

  setPassedPointFromPrevPage() {
    // when click "start tour from this place" in context menu
    const { passedPoint } = store.getState().mapScopeReducer;
    const { isSet, pointLoc, type } = passedPoint;
    if (isSet) {
      const { lat, lng } = pointLoc;
      publish(way.DRIVE_MAP_CLICK, { lat, lng, draggable: true, type });
      this.props.ownDispatch(removePassedPoint());
    }
  }

  cleanMapForNextData() {
    if (this.isAllMultiPartsPage()) allTourParts.notify(e.ATP_CLEAR_PART_DATA);
    else
      tourBuilder.notify(e.TB_CLEAR_PART_DATA, {
        wasEditModeChanged,
      });
  }

  disableReloadCommonPage = () => {
    const { isNeedReloadCommonPage, ownDispatch } = this.props;
    if (isNeedReloadCommonPage) {
      ownDispatch(disableReloadCommonPageAction());
    }
  };

  // Set address from drop-down in point list
  saveHomeAddressFromMap = (data) => {
    const { lat, lng } = store.getState().userReducer.homeAddress;
    if ((!lat && !lng) || data.lat !== lat || data.lng !== lng)
      this.props.ownDispatch(setHomeAddressUser(data));
  };

  saveWorkAddressFromMap = (data) => {
    const { lat, lng } = store.getState().userReducer.workAddress;
    if ((!lat && !lng) || data.lat !== lat || data.lng !== lng)
      this.props.ownDispatch(setWorkAddressUser(data));
  };
  //

  static updatePointAndPart(point) {
    if (point) {
      parts[point.part - 1].points.forEach((pt) => {
        if (point.id === pt.id) {
          pt.lat = point.lat;
          pt.lng = point.lng;
        }
      });
    }
  }

  actionPartByKey = (partId) => {
    const { isEditable } = this.props;
    const partKey = this.getPartKeyById(partId) + 1;

    if (isEditable && !isPrograssCompleted()) {
      setTimeout(() => {
        clearProgressList();
        console.info('Saving progress list was cleared');
      }, 2400);
      return;
    }

    if (typeof partKey === 'number')
      store.dispatch(tourOpenedMultiPartAction(partKey.toString()));

    store.dispatch(tourSetActiveMultiPartAction(partKey));
  };

  deleteTourPart = ({ partId, isMultyDay }) => {
    const partKey = this.getPartKeyById(partId);

    this.removePartByKey(partKey);
    this.actionPartByKey(partId);

    this.props.ownDispatch((dispatch) => {
      if (isMultyDay && parts.length <= 2) dispatch(setMultyTour(false));
      dispatch(deleteTourDay(partKey));
    });
  };

  upPointsTourPart = (
    partPoints,
    isDataWithEmptyPoints = false,
    isPrevPart = false
  ) => {
    const partPos = curPart ? curPart - 1 : 0;
    this.updatePartDistDuration(partPoints);
    if (isPrevPart) {
      this.props.ownDispatch(upTourPrevPartByPos(partPos, partPoints));
      return partPos;
    }

    this.props.ownDispatch(
      upTourPartByPos(partPos, partPoints, isDataWithEmptyPoints)
    );
    return partPos;
  };

  getDistanceAndDurationMainPart = () => {
    const tour = { ...this.props.tourFullData.data };

    if (tour.multiDay === true) {
      // eslint-disable-next-line
      const data = {
        distance: 0,
        duration: 0,
      };

      tour.parts.map((part) => {
        if (part.distance && part.duration) {
          data.distance += part.distance;
          data.duration += part.duration;

          return part;
        }
        part.points.map((point) => {
          if (point.distance) {
            data.distance += point.distance;
          }
          if (point.duration) {
            data.duration += point.duration;
          }

          return point;
        });

        return part;
      });

      if (data.distance === 0 || data.duration === 0) {
        return null;
      }

      this.props.ownDispatch(setMainTourPartDistanceAndDuration(data));

      return data;
    }
    return null;
  };

  updatePartDistDuration = (points) => {
    const data = {
      distance: 0,
      duration: 0,
      timestamp: 0,
    };

    // eslint-disable-next-line no-unused-vars
    const p = points.map((point) => {
      const { distance, duration } = point;
      if (distance) {
        data.distance += distance;
      }
      if (duration) {
        data.duration += duration;
      }
      return point;
    });
    this.getDistanceAndDurationMainPart();
    this.props.ownDispatch(setPostCountedData(data));
  };

  isMultyDay = () => this.props.tourFullData.data.multiDay === true;

  prepareOptimizedTourData = () => {
    this.props.ownDispatch(optimizeAndSaveTour(this.props.tourFullData.data));
  };

  setFreeHand = (val) => this.props.ownDispatch(setFreeHand(val));

  hideFreeHand = () => publish(way.DRIVE_MAP_HIDE_FREE_HAND_LAYER, {});

  setDistanceDurationByPartId = (data) =>
    this.props.ownDispatch(setDistanceDurationByPartId(data));

  setActivePoint = (point) =>
    store.dispatch(tourSetActiveMultiPartPointAction(point));

  getPartKeyById = (partId) => parts.map((o) => o.id).indexOf(partId);

  udatePartPointsData = (partPointsData) => {
    this.props.ownDispatch(
      upPartPoints(curPart ? curPart - 1 : 0, partPointsData)
    );
  };

  upPointsTourPartWithTimestamp = (timestamp, points) => {
    this.updatePartDistDuration(points);
    this.props.ownDispatch(
      upTourPartByPosWithTimestamp({
        partPos: this.getPartNum(),
        timestamp,
        points,
      })
    );
  };

  isAllMultiPartsPage = () => !curPart && parts && parts.length > 1;

  removePartByKey = (key) => parts.splice(key, 1);

  tourFullDataPointData = () => store.getState().tourFullData.dataPoint;

  isRidePlanMode = () =>
    this.props.tourFullData.activeMultiPart?.twister_data?.twister_type ===
    twisterType.RidePlan;

  isToPointMode = () =>
    this.props.tourFullData.activeMultiPart?.twister_data?.twister_type ===
    twisterType.ToPoint;

  isRoundTripMode = () =>
    this.props.tourFullData.activeMultiPart?.twister_data?.twister_type ===
    twisterType.RoundTrip;

  isFreeHandMode = () =>
    this.props.tourFullData.activeMultiPart?.twister_data?.twister_type ===
    twisterType.FreeHand;

  getCurrentMode = () => this.props.isEditable;

  getActiveMode = () =>
    this.props.tourFullData.activeMultiPart?.twister_data?.twister_type;

  getCorrectionStatus = () => this.props.tourFullData.isCorrectionEnabled;

  isAutocorrectionEnabled = () =>
    this.props.tourFullData.isAutocorrectionEnabled;

  isCorrectViaAvailable = () => this.props.tourFullData.isCorrectViaAvailable;

  isCorrectDragAvailable = () => this.props.tourFullData.isCorrectDragAvailable;

  unpaved = () => this.props.tourFullData.unpaved;

  highway = () => this.props.tourFullData.highway;

  ferry = () => this.props.tourFullData.ferry;

  isShapingVisible = () => this.props.tourFullData.isShapingVisible;

  getPointsData = () => this.props.tourFullData.activeMultiPart.pointsData;

  wasJustImported = () => this.props.tourFullData.wasJustImported;

  setDataSelectedPoint = (obj = {}) => {
    this.props.ownDispatch(tourPointDataAction(obj));
  };

  loadingDataStatusGPS = (obj) =>
    this.props.ownDispatch(setGPSDataLoadingStatus(obj));

  changeAutoCorrectStatus = (obj) =>
    this.props.ownDispatch(setAutoCorrectStatus(obj));

  getPartNum = () => (curPart ? curPart - 1 : 0);

  getCurrentPart = () =>
    this.props.multiData.parts
      ? this.props.multiData.parts[this.getPartNum()]
      : null;

  getCurPartPoly = () =>
    this.getCurrentPart() ? this.getCurrentPart().poly : null;

  saveRouteSuggestion = (obj) => this.props.ownDispatch(routeSuggestion(obj));

  goHistoryPrev = () => tourBuilder.notify(e.TB_HISTORY_PREV_STATE);

  goHistoryNext = () => tourBuilder.notify(e.TB_HISTORY_NEXT_STATE);

  openNotification = (isEdit = false, pressedDayKey = false) => {
    const { router, toogleEdit, currentPart } = this.props;
    const url = router ? router.location.pathname.split('/') : [];
    url.splice(-1, 1);
    const key = `open${Date.now()}`;
    const btn = (
      <Button
        type="primary"
        size="small"
        onClick={() => {
          notification.close(key);
          toogleEdit(isEdit);
          deleteTourDay(url, this.props.tourFullData, currentPart);
          if (pressedDayKey !== false) {
            const { data } = this.props.tourFullData;
            const selectKey = () => {
              if (+pressedDayKey) {
                return data.parts.length;
              }
              return 0;
            };
            this.props.ownDispatch((disp) => {
              disp(tourOpenedMultiPartAction(selectKey().toString()));
              disp(tourSetActiveMultiPartAction(selectKey()));
            });
          }
        }}
      >
        <span>{this.tr.Delete}</span>
      </Button>
    );
    notification.open({
      message: this.tr['No tour has been made'],
      description:
        this.tr[
          'To save this part of the tour you need to set at least a start and end point on the map.'
        ],
      btn,
      key,
    });
  };

  tourPartActionHandler = (topic, obj, isCurrPartCompleted = true) => {
    const { isEditable, tourFullData, ownDispatch } = this.props;
    const { data, activeMultiPart } = tourFullData;
    const key = obj.selectedPart;

    if (key === curPart && !obj.action) return;

    if (isEditable && !isPrograssCompleted()) {
      notification.warning({
        message: `${this.tr['Point address is loading']}...`,
      });
      console.info('Busy saving at this moment');
      setTimeout(() => {
        clearProgressList();
      }, 2400);
      return;
    }
    if (
      !isEditable ||
      (isEditable && (this.isAllMultiPartsPage() || isCurrPartCompleted))
    ) {
      if (isEditable && !data.id) {
        launchFunction(null, { activeMultiPart });
        setTimeout(() => {
          let param = { selectedPart: '2' };
          if (obj && obj.action && obj.action === 'via_part') {
            param = obj;
          }
          this.tourPartActionHandler('topic', param);
        }, 1000);
        return;
      }

      console.log('tour was saved');
      if (+key === data.parts.length + 1) {
        if (!this.isMultyDay()) {
          ownDispatch(setMultyTour(true));
          allTourParts.notify(way.SAVE_FIRST_PART_MULTIDAY, data);
        }
        if (obj && (!obj.action || obj.action !== 'via_part'))
          this.addNewMultiPart(data);
      }

      if (obj && obj.action && obj.action === 'via_part') {
        this.addViaMultiPart({ data, key: key - 1, points: obj.points });
      }

      store.dispatch((disp) => {
        disp(tourOpenedMultiPartAction(key));
        disp(tourSetActiveMultiPartAction(+key));
      });

      publish(way.DRIVE_MAP_STATIC_POINT_SELECTED, { customId: 0 });
    } else {
      this.openNotification(this.props.isEditable, key);
      console.log('Empty tour data');
    }
  };

  addViaMultiPart = ({ data, key, points = [] }) => {
    if (data) {
      const nextKey = +key + 1;
      const prevKey = +key - 1;

      if (points.length === 0) {
        const prevPointsPart =
          +key > 0
            ? data.parts[prevKey].points.map((i) => {
                delete i.id;
                return i;
              })
            : [];

        const nextPointsPart = data.parts[+key].points.map((i) => {
          delete i.id;
          return i;
        });

        switch (+key) {
          case 0:
            points.push({
              ...nextPointsPart[0],
              type: 'end',
              distance: 0,
              duration: 0,
            });
            break;
          default:
            points.push(
              {
                ...prevPointsPart[prevPointsPart.length - 1],
                type: 'start',
                distance: 0,
                duration: 0,
              },
              {
                ...nextPointsPart[0],
                type: 'end',
                distance: 0,
                duration: 0,
              }
            );
        }
      }

      this.props.ownDispatch((dispatch) => {
        dispatch({
          type: types.TOUR_FULL_DATA_ADD_VIA_DAY,
          payload: {
            part: {
              title: `Part ${nextKey}`,
              description: ``,
              images: [],
              allTourDays: data.parts.length + 1,
              parent_tour_id: Number(data.id),
              points: [...points],
              multiDay: true,
              part_id: nextKey,
              duration: 0,
              distance: 0,
              user: data.user,
              twister_data: {
                direction: 0,
                is_random: true,
                slider: 0,
                speed_profile: 0,
                twister_type: this.getActiveMode(),
              },
            },
            key: +key,
          },
        });
      });
    }
  };

  getStartPoint = (data) => {
    const lastIndex = data.parts.length - 1;
    const lastPointIndex = data.parts[lastIndex].points.length - 1;

    const latestPointPrevPart = {
      ...data.parts[lastIndex].points[lastPointIndex],
      distance: 0,
      duration: 0,
      type: 'start',
    };
    delete latestPointPrevPart.id;
    delete latestPointPrevPart.unique_id;

    return latestPointPrevPart;
  };

  addNewMultiPart = (data) => {
    const { ownDispatch } = this.props;
    if (data) {
      const newDay = {
        title: `Part ${data.parts.length + 1}`,
        description: ``,
        images: [],
        allTourDays: data.parts.length + 1,
        parent_tour_id: Number(data.id),
        points: [this.getStartPoint(data)],
        multiDay: true,
        part_id: data.parts.length + 1,
        duration: 0,
        distance: 0,
        user: data.user,
        twister_data: {
          direction: 0,
          is_random: true,
          slider: 0,
          speed_profile: 0,
          twister_type: this.getActiveMode(),
        },
      };
      ownDispatch(addNewDay(newDay));
    }
  };

  saveToLatestSearchAddress = (point) => {
    const { ownDispatch } = this.props;
    const { address, lat, lng } = point;
    if (address && lat && lng) {
      const data = {
        value: address,
        data: { lat, lng },
      };
      ownDispatch(setLatestSearchResult(data));
    }
  };

  getUrl = (router) => {
    const url = router ? router.location.pathname.split('/') : [];
    return url.splice(-1, 1);
  };

  handleClick = (queryText, clear = false) => {
    const { fullScreenMode, router, tourFullData, clearTour } = this.props;
    const { activeTourTab } = tourFullData;
    fullScreenMode('hidden', () => {});
    const url = this.getUrl(router);
    const func = clear ? clearTour : deleteTourDay;
    showDeleteConfirm(
      func,
      queryText,
      this.tr,
      url,
      tourFullData.data,
      activeTourTab
    );
  };

  getHtml = (style = {}) => {
    const { isEditable, isExistId, tourFullData } = this.props;
    const { activeTourTab } = tourFullData;
    if (isEditable) {
      return (
        <div className="tour_history_wrapper" style={style}>
          {(!isEditable && isExistId) || (isEditable && +activeTourTab > 0) ? (
            <Tooltip title={this.tr.Delete}>
              <Button
                size="large"
                className="tour_history_reset"
                onClick={() => {
                  this.handleClick(
                    +activeTourTab > 0
                      ? this.tr['Delete the day?']
                      : this.tr['Delete the tour?']
                  );
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          ) : (
            <Tooltip title={this.tr.Reset}>
              <Button
                size="large"
                className="tour_history_reset"
                onClick={() => {
                  this.handleClick(this.tr['Clear the tour?'], true);
                }}
              >
                <ResetIcon />
              </Button>
            </Tooltip>
          )}
          <Button.Group style={{ display: 'flex' }}>
            <Tooltip title={this.tr['Click to go back']}>
              <Button
                size="large"
                onClick={this.goHistoryPrev}
                className="tour_history_undo"
              >
                <UndoTourIcon />
              </Button>
            </Tooltip>
            <Tooltip title={this.tr['Click to go forward']}>
              <Button
                size="large"
                onClick={this.goHistoryNext}
                className="tour_history_redo"
              >
                <RedoTourIcon />
              </Button>
            </Tooltip>
          </Button.Group>
        </div>
      );
    }
    return '';
  };

  getStyleOverMap = () => {
    return {
      zIndex: 2147483647,
      position: 'absolute',
      left: '52px',
      top: '10px',
      display: 'flex',
    };
  };

  render() {
    const { isFullScreenModeEnabled } = this.props;
    const style = this.getStyleOverMap();
    if (isFullScreenModeEnabled) {
      return ReactDOM.createPortal(
        this.getHtml(style),
        document.querySelector('.TourFullmap')
      );
    }
    return this.getHtml();
  }
}

MultyBuilder.displayName = 'MultyBuilder';

const mapStateToProps = (store) => {
  return {
    tourFullData: store.tourFullData,
    currentPart: store.tourFullData.activeTourTab,
    isCorrectionEnabled: store.tourFullData.isCorrectionEnabled,
    isAutocorrectionEnabled: store.tourFullData.isAutocorrectionEnabled,
    isCorrectViaAvailable: store.tourFullData.isCorrectViaAvailable,
    isCorrectDragAvailable: store.tourFullData.isCorrectDragAvailable,
    isNeedReloadCommonPage: store.tourFullData.isNeedReloadCommonPage,
    isFullScreenModeEnabled: store.tourFullData.isFullScreenModeEnabled,
    unpaved: store.tourFullData.unpaved,
    highway: store.tourFullData.highway,
    ferry: store.tourFullData.ferry,
    isShapingVisible: store.tourFullData.isShapingVisible,
  };
};

export default connect(
  mapStateToProps,
  null
)(withDispatch(withTranslations(MultyBuilder)));
